module.exports = __webpack_public_path__ + "img/f.9b78287a.jpg";